import { z } from "zod";

/** `?tab=` on the sales invoices list, and `?due=` (the home's "Owed to you" tile links here). */
export const invoicesSearch = z.object({
  tab: z.enum(["all", "fix", "waiting", "accepted", "drafts"]).catch("all"),
  due: z.enum(["open", "overdue"]).optional().catch(undefined),
});
export type InvoicesTab = z.infer<typeof invoicesSearch>["tab"];
export type InvoicesDue = z.infer<typeof invoicesSearch>["due"];

/** `?type=` on the review queue: a family of typed reasons, or all of them; `?item=` is the one open beside it. */
export const reviewSearch = z.object({
  type: z.string().min(1).catch("all"),
  item: z.string().min(1).optional().catch(undefined),
});
